const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the top bar component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('contentTopBar', ['Application', 'Authorization', 'Analyze', 'MainComments', function (Application, Authorization, Analyze, MainComments) {
  return {
    restrict: 'E',
    scope: {
      contentTitle: '=',
      contentType: '=',
      contentId: '=',
      close: '=',
      specialClose: '&?',
      inTrack: '=',
      inJourney: '=?',
      trackComments: '&?',
      workshopComments: '&?',
      multiSessionWorkshopComments: '&?',
      editing: '=?',
      scormComments: '=?',
      hideContentComments: '=?',
      hideSlideIn: '=?'
    },
    template: require('../../templates/directives/content-top-bar.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.isInitialized = false;
      self.user = Authorization.getAuthToken().user;
      self.flags = Application.features.flags();
      self.shareOpen = false;
      var previousPage = Application.navigation.history.length - 2;
      self.commentCount = 0;
      self.navigateAway = function() {
        if ($scope.specialClose) {
          $scope.specialClose();
          return;
        }
        if ($scope.close === null) {
          Application.navigation.goTo('/explore', {});
          return;
        }
        if ($scope.close || $scope.close === 0) {
          Application.navigation.back($scope.close);
          return;
        }
        if (previousPage > 1 && self.contentType !== 'presentation') {
          Application.navigation.back(previousPage);
          return;
        }
        Application.navigation.goTo('/explore', {});
      };

      self.commentClick = function() {
        if ($scope.trackComments) {
          $scope.trackComments();
        }
        if ($scope.workshopComments) {
          $scope.workshopComments();
        }
        if ($scope.multiSessionWorkshopComments) {
          $scope.multiSessionWorkshopComments();
        }
      };

      self.initialize = function() {
        self.isInitialized = true;
        self.commentCount = 0;
        if (!$scope.contentType || $scope.contentType === 'quiz' || $scope.contentType === 'assessment') {
          self.contentType = $scope.contentType;
          self.contentId = $scope.contentId;
          return;
        }
        if ($scope.contentType && $scope.contentId) {
          self.contentType = $scope.contentType;
          self.contentId = $scope.contentId;
          Analyze.explore({content: [$scope.contentId], subresource: 'count-items'}).$promise
          .then(function(data) {
            var item = data.data[0];
            self.likes = 0;
            self.hasliked = false;
            self.shares = 0;
            self.hasShared = false;
            if (!item || typeof item !== 'object') {
              return;
            }
            self.likes = item.likes ? item.likes : 0;
            self.hasliked = item.hasliked;
            self.shares = item.shares ? item.shares : 0;
            self.hasShared = item.hasShared;
          }).catch(function(err) {
            console.log('Error getting card stats: ', err);
          });
          var findComments = false;
          var options = {removed: '$ne,true'};
          if (self.contentType === 'media' || self.contentType === 'video' || self.contentType === 'file') {
            options['media'] = self.contentId;
            findComments = true;
            if (!$scope.inTrack) {
              options['track'] = '$exists,false';
            }
          }
          if (self.contentType === 'article') {
            options['article'] = self.contentId;
            findComments = true;
            if (!$scope.inTrack) {
              options['track'] = '$exists,false';
            }
          }
          if (self.contentType === 'presentation') {
            options['presentation'] = self.contentId;
            findComments = true;
            if (!$scope.inTrack) {
              options['track'] = '$exists,false';
            }
          }
          if (self.contentType === 'workshop') {
            options['workshop'] = self.contentId;
            findComments = true;
          }
          if (self.contentType === 'multi_session_workshop') {
            options['multi_session_workshop'] = self.contentId;
            findComments = true;
          }
          if (self.contentType === 'imported_content') {
            options['imported_content'] = self.contentId;
            findComments = true;
          }
          if (self.contentType === 'scorm') {
            options['scorm'] = self.contentId;
            findComments = true;
          }
          if ($scope.inTrack) {
            options['track'] = $scope.inTrack;
          }

          if (self.contentType === 'track') {
            options['track'] = self.contentId;
            findComments = true; 
          }
          if (findComments) {
            MainComments.count(options).$promise
            .then(function(data) {
              self.commentCount = data.count || 0;
            });
          }
        }

      };

      self.showComments = function() {
        if (!self.contentType || $scope.hideContentComments) {
          return false;
        }

        if (self.contentType === 'scorm' && $scope.scormComments) {
          return true;
        }

        if (self.contentType !== 'track' && self.contentType !== 'scorm'&& self.contentType !== 'journey' && self.contentType !== 'assessment' && self.contentType !== 'quiz' && self.contentType !== 'presentation' && self.contentType !== 'workshop' && self.contentType !== 'multi_session_workshop' && !$scope.inTrack ) {
          return true;
        }
        return false;
      };

      $scope.$watchGroup(['contentId', 'contentType'], function (newVal, oldVal) {
        if (!self.isInitialized && newVal[0] && newVal[1]) {
          self.initialize();
        }
      });

      if ($scope.contentType && $scope.contentId) {
        self.initialize();
      } else {
        self.likes = 0;
        self.hasliked = false;
        self.shares = 0;
        self.hasShared = false;
        self.commentCount = 0;
      }

    }],
    controllerAs: 'bar'
  };
}]);
